import { render } from "./AddSchedule.vue?vue&type=template&id=66978ae1&scoped=true&ts=true"
import script from "./AddSchedule.vue?vue&type=script&lang=ts"
export * from "./AddSchedule.vue?vue&type=script&lang=ts"

import "./schedule.scss?vue&type=style&index=0&id=66978ae1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66978ae1"]])

export default __exports__